__turbopack_context__.v({
  "main": "main-module-scss-module__DWQBoW__main",
});
